import { REST_API } from '../../constants/restApiUrls';
import HttpConnection from '../../utils/http-connection';

/**
 * 選択肢情報を取得する
 *
 */
export async function getSelects() {
  const httpConnection = new HttpConnection();

  return httpConnection
    .get(REST_API.SETTING.MAIL_MAGAZINE_LIST.SELECT, {})
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

/**
 * 検索条件からメールマガジンを取得する
 *
 * @param {object} searchCondition
 */
export async function getDatas(searchCondition) {
  const httpConnection = new HttpConnection();
  return httpConnection
    .get(REST_API.SETTING.MAIL_MAGAZINE_LIST.MAIL_MAGAZINES, searchCondition)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

/**
 * メールマガジンを削除する
 *
 */
export async function deleteDatas(ids) {
  const httpConnection = new HttpConnection();
  return httpConnection
    .deletes(REST_API.SETTING.MAIL_MAGAZINE_LIST.MAIL_MAGAZINES, ids)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}
